import React from "react";


const Privacy = () => {
  return (

    <section className="terms-area pt-130 pb-130">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <h2 className="text-center title mb-4">Privacy Policy</h2>
            <p className="merriweather-sans text-center mb-04">At <b className="text-white">Diagnostica Solutions Pty Ltd</b> ("we", "us", "our"), your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your personal data when you use the <b className="text-white">DIAG Token </b>platform and <b className="text-white"> Diagnostica App </b>, available at https://diagnostica.app.

            </p>
          </div>
        </div>

        <div className="terms-content">
          <div className="pt-4">
            <h5 className="fw-title">1. Information We Collect</h5>
            <p className="merriweather-sans mb-0">We may collect the following types of information:
            </p>
            <ul className="merriweather-sans ps-4">
              <li className="list-circle"><b>Personal Data:</b> Name, email address, phone number, country of residence
              </li>
              <li className="list-circle"><b>Health Data (via the Diagnostica App): </b>Pain levels, PROM responses, wearable data (with user consent)
              </li>
              <li className="list-circle"><b>Blockchain Data: </b>Wallet address, transaction history</li>
              <li className="list-circle"><b>Device & Usage Data:</b> IP address, browser type, operating system, access times, and page views</li>
            </ul>
          </div>
          <div className="py-4">
            <h5 className="fw-title">2. How We Use Your Data</h5>
            <p className="merriweather-sans mb-0">We use your data to:</p>
            <ul className="merriweather-sans ps-4">
              <li className="list-circle">Provide access to app features and token utilities</li>
              <li className="list-circle">Personalize diagnostics and treatment insights</li>
              <li className="list-circle">Improve our AI models through anonymized data analysis</li>
              <li className="list-circle">Manage your token wallet, staking, and governance access</li>
              <li className="list-circle">Comply with legal and regulatory obligations</li>
            </ul>
          </div>

          <div>
            <h5 className="fw-title">3. Legal Basis for Processing</h5>
            <p className="merriweather-sans mb-0">We rely on:</p>
            <ul className="merriweather-sans ps-4">
              <li className="list-circle">User consent (for health and device data)</li>
              <li className="list-circle">Contractual necessity (for service access)</li>
              <li className="list-circle">Legitimate interest (for platform improvement and fraud prevention)</li>
              <li className="list-circle">Legal obligations (AML/KYC, data retention)</li>
            </ul>
          </div>

          <div className="py-4">
            <h5 className="fw-title">4. How We Protect Your Data</h5>
            <ul className="merriweather-sans ps-4">
              <li className="list-circle">End-to-end encryption of sensitive information</li>
              <li className="list-circle">Data stored on secure servers in compliance with GDPR and HIPAA</li>
              <li className="list-circle">Blockchain records are immutable but anonymized</li>
              <li className="list-circle">Access controls and regular audits ensure minimal exposure</li>
            </ul>
          </div>
          <div className="py-2">
            <h5 className="fw-title">5. Data Sharing & Third Partiest</h5>
            <p className="merriweather-sans mb-0">We do not sell your data. We may share it with:</p>
            <ul className="merriweather-sans ps-4">
              <li className="list-circle">Technology partners (e.g., Oracle, Samsung) for device integration</li>
              <li className="list-circle">Health professionals (only with user consent)
              </li>
              <li className="list-circle">Regulatory bodies, if required by law
              </li>
            </ul>
          </div>
          <div className="py-4">
            <h5 className="fw-title">6. Your Rights</h5>
            <p className="merriweather-sans mb-0">Under GDPR and similar laws, you have the right to:
            </p>
            <ul className="merriweather-sans ps-4">
              <li className="list-circle">Access or correct your personal data</li>
              <li className="list-circle">Withdraw consent at any time</li>
              <li className="list-circle">Request deletion or restriction</li>
              <li className="list-circle">Request deletion or restriction</li>
            </ul>
          </div>
          <div>
            <h5 className="fw-title">7. Data Retention</h5>
            <p className="merriweather-sans mb-0">We retain your data:
            </p>
           <ul className="merriweather-sans ps-4">
             <li className="list-circle">For as long as your account is active</li>
            <li className="list-circle">To comply with legal obligations (e.g., financial records)</li>
            <li className="list-circle">Anonymized data may be used for long-term AI training and analytics</li>
           </ul>
          </div>
          <div className="py-4">
            <h5 className="fw-title">8. Children’s Privacy</h5>
            <p className="merriweather-sans mb-0">DIAG is not intended for users under 18 years of age. We do not knowingly collect data from minors.
            </p>
          </div>
          <div>
            <h5 className="fw-title">9. Changes to This Policy</h5>
            <p className="merriweather-sans">We may update this policy periodically. The revised version will be posted on this page with a new effective date.</p>
          </div>
          <div className="py-2">
            <h5 className="fw-title">10. Contact Us</h5>
            <p className="merriweather-sans">For privacy concerns, contact:
              <a href="mailto:diag@diagnostica.app"> diag@diagnostica.app</a></p>
          </div>



        </div>
      </div>
    </section>



  );
};

export default Privacy;
